/**
 * Format one team's set score for display. In a tiebreak set (7–6), the team
 * that lost the set shows its tiebreak points in parentheses:
 *   winner → "7", loser → "6(4)"  (4 = loser's tiebreak points)
 */
export function formatSetScore(
  teamGames: number | null,
  oppGames: number | null,
  tiebreakScore: number | null | undefined
): string {
  if (teamGames == null || oppGames == null) return '';
  const isTiebreak =
    (teamGames === 7 && oppGames === 6) || (teamGames === 6 && oppGames === 7);
  if (isTiebreak && tiebreakScore != null && teamGames === 6) {
    return `6(${tiebreakScore})`;
  }
  return String(teamGames);
}
